import { ReactElement, useState, Children, useEffect } from "react";
import { Button, Col, Form, notification, Row, Space, Spin, Divider,  } from "antd";
import { LoadingOutlined, RollbackOutlined } from "@ant-design/icons";
import isEqual from 'lodash/isEqual';

type SettingsSectionFormProps<T> = {
  children: ReactElement | ReactElement[];
  initialValues: Partial<T>;
  onSubmit: (values: T) => Promise<any>;
}

export const SettingsSectionForm = <T extends object>({
  children,
  initialValues,
  onSubmit,
}: SettingsSectionFormProps<T>) => {
  const [form] = Form.useForm<T>()
  const [loading, setLoading] = useState(false)
  const [disabledButtons, setDisabledButtons] = useState(true)
  const handleFinish = async (values: T) => {
    setLoading(true)
    try {
      await onSubmit(values)
      setDisabledButtons(true)
    } catch (description: any) {
      notification.error({
        message: "Изменения не сохранились",
        duration: 2,
        description,
      })
    } finally {
      setLoading(false)
    }
  }
  const handleSubmit = () => {
    form.submit()
  }
  const handleReset = () => {
    setDisabledButtons(true)
    form.resetFields()
  }

  useEffect(() => {
    return form.setFieldsValue(initialValues as any);
  }, [form, initialValues])

  return (
    <Form
      onValuesChange={(_, values) => {
        setDisabledButtons(isEqual(values, initialValues))
      }}
      initialValues={initialValues}
      preserve={false}
      scrollToFirstError={true}
      form={form}
      labelWrap
      autoComplete="off"
      onFinish={handleFinish}
      layout="vertical"
    >
      <Spin
        spinning={loading}
        size="default"
        indicator={<LoadingOutlined spin />}
        tip="Сохранение"
      >
        {Children.map(children, (child => (
          <>
            {child}
            <Divider />
          </>
        )))}
      </Spin>
      <Row justify="end">
        <Space>
          {!disabledButtons && (
            <Col>
              <Button
                type="text"
                shape="round"
                icon={<RollbackOutlined />}
                disabled={loading}
                onClick={handleReset}
              >
                Отменить изменения
              </Button>
            </Col>
          )}
          <Col>
            <Button
              disabled={disabledButtons}
              loading={loading}
              onClick={handleSubmit}
            >
              Сохранить
            </Button>
          </Col>
        </Space>
      </Row>
    </Form>
  )
}